import styled from "@emotion/styled";
import theme from "@theme";

const FilterContainer = styled.div`
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 16px 24px;
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

  @media (max-width: 768px) {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
`;
const BodyHeader = styled.div`
  padding: 12px 20px;
  background-color: #f7f9f7;
  border-bottom: 1px solid ${theme.colors.bordertask};
  position: fixed;
  width: 100%;
  z-index: 1000;
`;
const CardContainerStyle = styled.div`
  margin: 10px;
  padding: 5px 10px 5px 10px;
  border: 1px solid ${theme.colors.bordertask};
  border-radius: 8px;
`;
const LeasingLayout = styled.div`
  border-bottom: 1px solid ${theme.colors.bordertask};
`;

const SC = {
  FilterContainer,
  BodyHeader,
  CardContainerStyle,
  LeasingLayout,
};

export default SC;
